var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicDisabledIconinline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.893 15.8V8.333c0-2.213-1.786-4-4-4a3.972 3.972 0 00-3.946 3.534l7.946 7.933zm4.107.533c-.547 0-1.027.4-1.107.947-.066.427-.16.853-.293 1.24l1.693 1.693c.4-.8.694-1.666.84-2.586A1.143 1.143 0 0025 16.333zM5.84 6.413c-.52.52-.52 1.36 0 1.88l7.053 7.067v.573c0 1.587.8 3.094 2.174 3.88 1 .574 1.88.587 2.693.414l2.213 2.213c-.946.44-2 .693-3.08.693-3.386 0-6.506-2.36-7-5.853a1.118 1.118 0 00-1.106-.947c-.694 0-1.227.614-1.134 1.294.614 3.946 3.947 7.066 7.907 7.666v3.04c0 .734.6 1.334 1.333 1.334.734 0 1.334-.6 1.334-1.334v-3.04a9.505 9.505 0 003.4-1.2l4.653 4.654c.52.52 1.36.52 1.88 0 .52-.52.52-1.36 0-1.88L7.72 6.413c-.52-.52-1.36-.52-1.88 0z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicDisabledIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic-disabled-icon.inline.9284f539d3f0ce9448ff902ffbc8b1d7.svg";